if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.button__label').classList.add('hidden');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const productDetails = JSON.parse(this.querySelector('[data-product-json]').textContent);

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: `application/json`,
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const showMiniCart = formData.get('show_mini_cart') === 'true';
      const redirectToCartOnAddProduct = formData.get('redirect_to_cart_on_add_product') === 'true';

      const giftWrapping = document.querySelector('gift-wrapping');

      if (giftWrapping && giftWrapping.querySelector('.disclosure__link--active').dataset.value != '') {
        const giftWrappingId = giftWrapping.querySelector('.disclosure__link--active').dataset.value;
        const giftWrappingName = giftWrapping.querySelector('.disclosure__link--active').dataset.name;
        const variantId = this.form.querySelector('[name="items[0]id"]').value;

        const parentKey =  window.btoa([giftWrappingId, variantId].join(','));
        formData.append('items[0]properties[_itemKey]', parentKey);
        formData.append(`items[0]properties[${window.variantStrings.gift_wrapping.wrapping_property_label || 'Gift wrapping'}]`, giftWrappingName);
        formData.append('items[1]id', giftWrappingId);
        formData.append('items[1]properties[_parentKey]', parentKey);
        formData.append('items[1]properties[_giftWrapping]', 'true');
        formData.append(`items[1]properties[${window.variantStrings.gift_wrapping.product_property_label || 'Product'}]`, productDetails.product.title);
      }

      config.body = formData;

      let gotError = false;
      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        if (res.status !== 200) {
          if (json.description?.email) {
            throw new Error(json.description.email);
          }
          if (json.description?.message) {
            throw new Error(json.description.message);
          }
          if (json.description?.name) {
            throw new Error(json.description.name);
          }
          throw new Error(json.description);
        }

        const productQuantity = formData.get('quantity');

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { json, showMiniCart }
        }));

        const isBundle = json?.items?.[0] && !json?.items?.[0]?.sku;
        document.dispatchEvent(new CustomEvent('datalayer:productAdded', {
          detail: {
            product: productDetails,
            quantity: productQuantity ? parseInt(productQuantity) : 1,
            price: json?.items?.[0]?.price,
            bundled: isBundle,
            ...(isBundle
              ? { bundleProduct:
                {
                  title: productDetails.product.title,
                  handle: productDetails.product.handle
                }
              }
              : {}
            ),
            affiliatePartner: window.localStorage.getItem('affiliatePartner'),
            affiliateId: window.localStorage.getItem('affiliateId'),
            ttp: window.getCookieValue('_ttp'),
            ttclid: window.getCookieValue('ttclid'),
            eventId: crypto.randomUUID()
          }
        }));

        if (!showMiniCart && redirectToCartOnAddProduct) {
          setTimeout(() => {
            window.location.pathname = window.routes.cart_url;
          }, 100);
        }
      } catch (error) {
        gotError = true;
        this.handleErrorMessage(error);
        console.error(error);
      }

      this.querySelector('.loading-overlay__spinner').classList.add('hidden');

      let completedTimeout = 2000;
      if (!gotError) {
        setTimeout(() => {
          this.querySelector('.loading-overlay__completed').classList.remove('hidden');
        }, 100);
        this.querySelector('.product-form_cart-link')?.classList.remove('hidden');
      } else {
        completedTimeout = 0;
      }

      setTimeout(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.querySelector('.button__label').classList.remove('hidden');
        this.querySelector('.loading-overlay__completed').classList.add('hidden');
      }, completedTimeout);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {

        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
